import { TextareaInput } from '../baseInputs'

type Props = {
  helper?: string
  optional?: boolean
  characterLimit?: number
}

const Notes = ({ helper, optional, characterLimit = 144 }: Props) => {
  const name = 'notes'
  const label = 'Additional comments or questions'

  return (
    <TextareaInput
      name={name}
      label={label}
      helper={helper}
      optional={optional}
      characterLimit={characterLimit}
    />
  )
}

export default Notes
